/** GxBreachChips: the chips under a projected value that lands outside a limit, the regulator's minimum in the critical tone and the player's own limit in the warning tone (Decide's preview rows and the event cards' "after" facts). */
import { GxBadge } from "./primitives";

export interface BreachChip { readonly text: string; readonly level: "regulatory" | "own" }

export function GxBreachChips({ breaches, testId }: { readonly breaches: readonly BreachChip[]; readonly testId?: string }) {
  if (breaches.length === 0) return null;
  return <div className="gx-breach" data-testid={testId}>{breaches.map((b) => <GxBadge key={b.text} tone={b.level === "regulatory" ? "crit" : "warn"}>{b.text}</GxBadge>)}</div>;
}
